module.exports = __webpack_public_path__ + "static/nollVision1-85eb203744b1e6af2d770e136c73f881.jpg";